import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import Modal from '@mui/material/Modal'
import { useLangStore } from 'store/authAtom'
import captcha from 'resources/images/captcha.png'
import success from 'resources/images/success.png'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: 10,
}
const LittleBox = {
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderWidth: 0,
    borderRadius: '8px 8px 8px 8px',
}
export default function CaptchaMotal({ isOpen, onClose }) {
    return (
        <Modal
            sx={{
                '.MuiBox-root:focus-visible': {
                    outline: 'none',
                    border: 'none',
                },
                zIndex: 100,
            }}
            open={isOpen}
            onClose={onClose}
            slotProps={{
                root: { className: 'shadow-card' },
                backdrop: {
                    style: {
                        backdropFilter: 'blur(10px)',
                        WebkitBackdropFilter: 'blur(10px)', // 兼容 Safari
                        backgroundColor: 'rgba(34, 34, 34, 0.2)',
                    },
                },
            }}
        >
            <Box sx={style}>
                <Box sx={LittleBox} className='overflow-hidden'>
                    <Box sx={{ p: '10px' }}>
                        <IframeComponent />
                    </Box>
                    <Box
                        className='icon-close'
                        sx={{
                            zIndex: 50,
                            position: 'absolute',
                            top: 40,
                            right: { xs: 80, md: 80 },
                            cursor: 'pointer',
                            p: { xs: '0  8px 8px 0', md: 0 },
                            color: '#231448',
                            fontSize: '14px',
                            fontWeight: 'bold',
                        }}
                        onClick={onClose}
                    ></Box>
                </Box>
            </Box>
        </Modal>
    )
}

const IframeComponent = () => {
    const lang = useLangStore((state) => {
        let language = 'en'
        if (state.lang === 'zh_HK') {
            language = 'cn_hk'
        } else if (state.lang === 'zh_CN') {
            language = 'cn'
        }
        return language;
    })
    // 拼接配置参数
    const config = {
        appId: process.env.REACT_APP_CAPTCHA_APPID, //appId，在控制台应用管理或应用配置模块获取
        apiServer: 'https://cap.aisecurius.com',
        language: lang,
        success: (token) => {
            window.parent?.postMessage({ token })
        },
        customStyle: {
            bar: {
                slidingBdColor: '#D6093B',
                slidingBgColor: '#FFE7EC',
                normalTextColor: '#231448',
                successBgColor: '#E9ECF3',
                successBdColor: '#E9ECF3',
                failBgColor: '#FFE7EC',
                failBdColor: '#D6093B',
                successIcon: success,
            },
            background: '#E9ECF3',
            slider: {
                normalBgSrc: captcha,
                focusBgSrc: captcha,
                hoverBgSrc: captcha,
            },
        },
    }

    useEffect(() => {
        window._dx.Captcha(document.getElementById('c1'), config)
    }, [])

    return (
        <div id="c1"></div>
    )
}
